// @ts-nocheck
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';
import { Formik } from 'formik';
import { Intent } from '@blueprintjs/core';

import '@/style/pages/Preferences/GeneralForm.scss';

import { AppToaster } from '@/components';
import GeneralForm from './GeneralForm';
import { PreferencesGeneralSchema } from './General.schema';
import { useGeneralFormContext } from './GeneralFormProvider';
import withDashboardActions from '@/containers/Dashboard/withDashboardActions';

import { compose, transformToForm } from '@/utils';

const defaultValues = {
  name: '',
  industry: '',
  uuid: '',
  custom_id: '',
  model: '',
  CRN_number: '',
  location: '',
  location_city: '',
  location_city_subdivision: '',
  location_street: '',
  location_plot_identification: '',
  location_building: '',
  location_postal_zone: '',
  logo: '',
  base_currency: '',
  language: '',
  fiscal_year: '',
  date_format: '',
  timezone: '',
  tax_number: '',
  zatca_mode: null,
  zatca_on: false,
  zatca_otp: '',
  user_type: ''
};

const normalizeZatcaValues = (values) => ({
  ...values,
  zatca_sandbox_url:
    values.zatca_mode === 'sandbox' ? values.zatca_sandbox_url : null,
  zatca_production_url:
    values.zatca_mode === 'production' ? values.zatca_production_url : null,
});

/**
 * Preferences - General form Page.
 */
function GeneralFormPage({
  // #withDashboardActions
  changePreferencesPageTitle,
}) {
  const { updateOrganization, organization } = useGeneralFormContext();

  useEffect(() => {
    changePreferencesPageTitle(intl.get('general'));
  }, [changePreferencesPageTitle]);

  // Initial values.
  const initialValues = {
    ...defaultValues,
    ...transformToForm(organization.metadata, defaultValues),
  };

  const handleFormSubmit = (values, { setSubmitting }) => {
    updateOrganization(normalizeZatcaValues(values))
      .then(() => {
        AppToaster.show({
          message: intl.get('preferences.general.success_message'),
          intent: Intent.SUCCESS,
        });
        setSubmitting(false);
        if (organization.metadata?.language !== values.language) {
          window.location.reload();
        }
      })
      .catch(() => setSubmitting(false));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
      component={GeneralForm}
    />
  );
}

export default compose(withDashboardActions)(GeneralFormPage);
